export function getDuplicatedColumnTemplateError(id: string) {
  return new Error(`[qtek] Template for id: ${id} is alredy defined.`);
}

export function getMinMaxWidthMismatchError() {
  return new Error('[qtek] minimal width is larger then maximum width.');
}

export function getUniqueHideOrderError() {
  return new Error('[qtek] hideOrder is not unique.');
}

export function getDuplicatedColumnFormatTemplateError(format: string) {
  return new Error(`[qtek] Template for format: ${format} is alredy defined.`);
}
